/* tslint:disable */
/* eslint-disable */
/**
 *
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface PatchedProjectArea
 */
export interface PatchedProjectArea {
  /**
   *
   * @type {string}
   * @memberof PatchedProjectArea
   */
  type?: PatchedProjectAreaTypeEnum;
  /**
   *
   * @type {Array<Array<Array<number>>>}
   * @memberof PatchedProjectArea
   */
  coordinates?: Array<Array<Array<number>>>;
}

/**
 * @export
 */
export const PatchedProjectAreaTypeEnum = {
  Polygon: "Polygon",
} as const;
export type PatchedProjectAreaTypeEnum =
  (typeof PatchedProjectAreaTypeEnum)[keyof typeof PatchedProjectAreaTypeEnum];

/**
 * Check if a given object implements the PatchedProjectArea interface.
 */
export function instanceOfPatchedProjectArea(value: object): value is PatchedProjectArea {
  return true;
}

export function PatchedProjectAreaFromJSON(json: any): PatchedProjectArea {
  return PatchedProjectAreaFromJSONTyped(json, false);
}

export function PatchedProjectAreaFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PatchedProjectArea {
  if (json == null) {
    return json;
  }
  return {
    type: json["type"] == null ? undefined : json["type"],
    coordinates: json["coordinates"] == null ? undefined : json["coordinates"],
  };
}

export function PatchedProjectAreaToJSON(json: any): PatchedProjectArea {
  return PatchedProjectAreaToJSONTyped(json, false);
}

export function PatchedProjectAreaToJSONTyped(
  value?: PatchedProjectArea | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    type: value["type"],
    coordinates: value["coordinates"],
  };
}
